import type { TFurniture } from "types/elevationReferences.type"

export const isCountertop = (item: TFurniture) => item.top_level_category?.name === "Countertops"
export const isModelConfirmed = (item: TFurniture) => item.selected_model_number !== null
export const isOtherFurniture = (item: TFurniture) =>
	item.top_level_category == null && item.super_category == null && item.category == null

/**
 * Returns the furniture as an "Other" item: every category level forced to null,
 * all other fields preserved. The category levels must be cleared explicitly
 * (not left to the PATCH response) because `spliceFurnitureIntoCache` merges, so
 * a stale category would otherwise survive and hide the "Other" label.
 * Invariant: `isOtherFurniture(asOtherFurniture(item))` is always true.
 */
export const asOtherFurniture = (item: TFurniture): TFurniture => ({
	...item,
	category: null,
	super_category: null,
	top_level_category: null,
})
